import { styled } from '@compiled/react';
import Heading from '@atlaskit/heading';
import { token } from '@atlaskit/tokens';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const PageTitle = styled(Heading)({
	textOverflow: 'ellipsis',
	overflow: 'hidden',
	whiteSpace: 'nowrap',
	marginTop: 0,
	paddingTop: token('space.050'),
	paddingRight: token('space.075'),
	paddingBottom: token('space.050'),
	paddingLeft: token('space.075'),
});
